import { ContentPanel, EtfLabel } from 'shared/ui-kit';

import { IEtfCorrelationBackend } from 'api/correlations';
import { useMemo } from 'react';
import classNames from 'classnames';

import styles from './connections.module.scss';
import { style } from 'd3';

export interface EftCorrelationPageConnectionsProps {
	ticker: string;
	correlations: IEtfCorrelationBackend[];
	className?: string;
}
export const EftCorrelationPageConnections = (props: EftCorrelationPageConnectionsProps) => {
	const [similar, antipods] = useMemo(
		() => {
			var similar = props.correlations
				.filter(x => x.correlation != 0)
				.sort((first, second) => (second.correlation || 0) - (first.correlation || 0))
				.filter(x => (x.correlation || 0) > 0.5)
				.splice(0, 5);

			var antipods = props.correlations
				.filter(x => x.correlation != 0)
				.sort((first, second) => (first.correlation || 0) - (second.correlation || 0))
				.filter(x => (x.correlation || 0) < -0.5)
				.splice(0, 5);

			return [similar, antipods];
		},
		props.correlations);

	return (
		<ContentPanel title="Важные связи" className={props.className}>
			<div className={styles.container}>
				<EtfColumn key="dependent" title="Фонды зависимые" items={similar} />
				<EtfColumn key="antipods" title="Фонды антиподы" items={antipods} />
			</div>
		</ContentPanel>
	);
}

interface EtfColumnProps {
	title: string;
	items: IEtfCorrelationBackend[];
}
const EtfColumn = (props: EtfColumnProps) => {
	return (
		<p className={styles.column}>
			<span className={styles.title}>{props.title}:</span>
			<span className={styles.items}>
				{
					props.items.length === 0
						? <span className={styles.no_data}>Не обнаружено</span>
						: props.items.map(x => <span className={styles.item}><EtfLabel ticker={x.ticker} allowNavigation /></span>)
				}
			</span>
		</p>
	)
}
